import './form-check.scss';
import { Form } from 'react-bootstrap';
import { FormCheckBaseProps, formCheckClassName } from './form-check-utils';

type RadioProps = FormCheckBaseProps;

export const Radio = ({ className, size, background, ...passthrough }: RadioProps) => (
  <Form.Check
    {...passthrough}
    type='radio'
    className={formCheckClassName({ size, background }, className)}
  />
);
